<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/MCqgLP/tc-custom/9781504083768.jpg?1726444246414" alt="This image is the cover for the book Hills Like White Elephants"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Hills Like White Elephants
      </h1>
      <p class="bookDescription body article font2">
        <p><b>A couple’s future hangs in the balance as they wait for a train in a Spanish café in this short story by a Nobel and Pulitzer Prize–winning author.</b></p><p> At a small café in rural Spain, a man and woman have a conversation while they wait for their train to Madrid. The subtle, casual nature of their talk masks a more complicated situation that could endanger the future of their relationship. </p> First published in the 1927 collection <i>Men Without Women</i>, “Hills Like White Elephants” exemplifies Ernest Hemingway’s style of spare, tight prose that continues to win readers over to this day.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ernest Hemingway
      </h2>
      
      <p class="authorDescription body article">Ernest Hemingway was an American journalist, novelist, short story writer, and sportsman. His economical and understated style, which he termed&#160;&ldquo;the iceberg theory,&rdquo; had a strong influence on twentieth-century fiction, while his adventurous lifestyle and public image brought him admiration from later generations.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?17648f4d